
















































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import _ from "lodash";
import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() mobiles!: string;

  @Prop() sign!: string;

  @Prop() kinds!: string;

  @Prop() content!: string;

  @Prop() rules!: string;

  @Prop() platformId!: number;

  remnant = 0;

  mobilenum = 0;

  percount = 70;

  totalcount = 0;

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要发送短信吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("sms/add", {
              mobiles: this.mobiles,
              kinds: this.kinds,
              sign: this.sign,
              content: this.content,
              rules: this.rules,
              sms_platform: this.platformId,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
              this.handleCancel();
            } else {
              this.$message.error(res.Message);
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }

  mounted() {
    this.spinLoading = true;
    // console.log(this.mobiles)
    const arr: string[] = _.split(this.mobiles, ",");
    this.mobilenum = arr.length;
    this.remnant = `【${this.sign}】${this.content}`.length;
    // 手机号一批200个，只实现上亿的话，上亿一次5000个手机号
    const mobilecount: number =
      this.mobilenum * Math.ceil(this.mobilenum / 5000);

    // 扣费条数，70 个字一条，超出 70 个字时按每 67 字一条计
    let count: number = this.percount;
    if (this.remnant > 70) {
      count = 67;
    }
    this.totalcount = Math.ceil(this.remnant / count) * mobilecount;
    this.spinLoading = false;
  }
}
